var $ = require('jquery')
  , Tabs = require('ui/tabs')

require('@173js/ui/preventEmptyHrefClick')
require('./setupModVideo')

var pandora = window.pandora

$(function() {
  var tabContentsContainer = $('.tab-pn')
    , tabContents = tabContentsContainer.find('.tab-content')
    , tabNavContainer = $('.tab-nav-container')
    , tabNav = tabNavContainer.find('.tab-nav')
    , tabNavItems = tabNav.find('.tab-nav-item')
    , tabs = new Tabs(tabNavItems, tabContents)
    , tabNavHasFixed = false

  tabs._trunTo = tabs.turnTo;
  tabs.turnTo = function(tabIndex){
    tabs._trunTo(tabIndex);
    pandora.use(['gallery'], function(Gallery) {
      var galleryContainer = tabContents.find('.ue-gallery').eq(tabIndex)

      galleryContainer.show()
      new Gallery({ element: galleryContainer })
    })
  }

  tabs.initState(0)

  var win = $(window)
    , doc = $(document)
    , tabNavInitTop = tabNav.offset().top

  win.scroll(function() {
    var tabNavWillBeFixed = doc.scrollTop() > tabNavInitTop

    tabNav[tabNavWillBeFixed ? 'addClass': 'removeClass']('fixed')
    var avatarHeight = tabNavWillBeFixed ? '65px' : '90px'

    tabNav.find('.avatar')
      .css({ width: avatarHeight, height: avatarHeight })

    tabNav.find('.br')[tabNavWillBeFixed ? 'hide' : 'show']()
    tabNavContainer.find('.mask')[tabNavWillBeFixed ? 'show' : 'hide']()
    tabContentsContainer.css('marginTop', tabNavWillBeFixed ? '200px': '0')
    tabNavHasFixed = tabNavWillBeFixed
  })

  var tabContentsContainerTop = tabContentsContainer.offset().top

  tabContents.on('tab:show', function(e) {
    if (!tabNavHasFixed) { return }
    window.scroll(0, tabContentsContainerTop - 250)
  })
})
